import React, { useContext, useEffect, useState } from "react";
import TertiaryButton from "../buttons/TertiaryButton";
import Image from "../images/Image";
import { useNavigate } from "react-router-dom";
import { signOut } from "@aws-amplify/auth";
import GlobalContext from "../Context/GlobalContext";
import CustomModal from "../CustomModal";
import { showToast } from "../toastMessage/toastSlice";
import { useDispatch } from "react-redux";
import LanguageChanger from "../LanguageChangerDropdown";
import { SideBarContent } from "./SideBarContent";
import useTranslation from "../CustomHooks/useTranslation";
import { fetchAuthSession } from 'aws-amplify/auth';

const Topbar: React.FC = () => {
  const buttons = ['Career', 'Blog', 'Job Application'];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsLoggedIn } = useContext(GlobalContext)
  const [isOpen, setIsOpen] = useState(false)
  const { translate } = useTranslation(SideBarContent);
  const [initials, setInitials] = useState('GG')

  const clickLogout = () => {
    setIsLoggedIn(false)
    signOut();
    localStorage.clear();
    dispatch(showToast({ type: "success", message: "Logout successful" }));
    navigate('/');
    setIsOpen(false)
  }
  const getUserName = async () => {
    let user = await fetchAuthSession({ forceRefresh: true });
    if (user) {
      let key = user?.tokens?.idToken?.payload?.name;
      if (!key || typeof key !== "string") return "";

      const words = key.trim().split(/\s+/); // Split by spaces

      if (words.length > 1) {
        setInitials((words[0][0] + words[1][0]).toUpperCase()); // Two words → First letter of both
      } else if (words[0].length > 1) {
        setInitials(words[0].slice(0, 2).toUpperCase()); // One word → First two letters
      } else {
        setInitials(words[0][0].toUpperCase()); // One letter → Return as uppercase
      }
    };

  }
  useEffect(() => {
    getUserName()
  }, []);
  return (
    <div className="bg-white  flex justify-end items-center h-[100px]">
      {/* <h1 className="text-lg font-semibold">Admin Panel</h1> */}
      <div className=" w-fit flex gap-[50px] py-5 pr-10 items-center">
        {buttons.map((buttonItem) => (
          <TertiaryButton key={buttonItem} buttonName={translate(buttonItem)} id={buttonItem} />
        ))}
        <div className=" text-p_primary subTitle flex items-center">
          <LanguageChanger image="chevron-down-blue" />
        </div>
        <div data-testid="profile" className="h-[60px] w-[60px] bg-p_light rounded-full flex items-center justify-center cursor-pointer" onClick={() => navigate('/view-profile')}>
          <p className="w-full text-center">{initials}</p>
        </div>
        <Image src="log-out" className="h-6 w0-6 cursor-pointer" onClick={() => setIsOpen(true)} testId={'logout'} />
        <CustomModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          title="Logout"
          subText="Are you sure you want to logout?"
          primaryButtonText="Logout"
          secondaryButtonText="Cancel"
          handelSubmit={clickLogout}
          buttonWidth="w-[85px]"
        />
      </div>
    </div>
  );
};

export default Topbar;